import { render, staticRenderFns } from "./SparringAdminView.vue?vue&type=template&id=a068237e&scoped=true"
import script from "./SparringAdminView.vue?vue&type=script&lang=ts&setup=true"
export * from "./SparringAdminView.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SparringAdminView.vue?vue&type=style&index=0&id=a068237e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a068237e",
  null
  
)

export default component.exports